export default {
    partner_icons: {
        name: '',
        fields: {
            icon: 'พาร์ทเนอร์ไอคอน',
            create: {title: 'สร้าง Parthner Icon'}
        }
    }
}